export default __webpack_public_path__ + "static/media/landing_section_img_3.a7d7beb3.png";